module.exports = __webpack_public_path__ + "static/media/white-banner.6e9ab17d.jpg";